import { Injectable } from '@angular/core';
import { HttpClient, HttpEventType, HttpHeaders } from '@angular/common/http';
import { AppService } from 'src/app/app.service';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { s3BucketParams } from '../shared.models';
import { environment } from '@env/environment';


@Injectable({
    providedIn: 'root'
})

export class AWSS3Service {

    constructor(
        private _appService: AppService,
        private http: HttpClient
    ) {

    }

    public generateRandomString() {
        var text = "";
        var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
        for (var i = 0; i < 10; i++)text += possible.charAt(Math.floor(Math.random() * possible.length));
        return text;
    }

    getHeadersLambda(): any {
        let headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + this._appService.token
        })

        return ({ headers: headers });
    }

    private _generate_url(url, data, file): Observable<any> {
        let API_URL = environment.urlAPIBucket + '/files/url/';
        return this.http.post(API_URL + url, data, this.getHeadersLambda()).pipe(
            map((response: any) => {
                return response;
            }),
        );
    }

    /**
     * 
     * @param path: Es la ruta que contiene el ``bucket`` + ``folderKey`` + ``fileName`` encritado con window.btoa()
     * @param data
     * @param file 
     * @returns 
     */
    generate_url(path: string, data: s3BucketParams, file: File, onProgress?: (percent: number) => void): Observable<any>{
        return new Observable ((observer) => {
            this._generate_url(path, data, file).subscribe({
                next: (response) => {
                    const { status, data } = response;

                    if (status == true) {

                        const { AWSAccessKeyId, policy, signature, key } = data.fields;
                        const xAmzSecurityToken = data.fields.hasOwnProperty('x-amz-security-token') ? data.fields['x-amz-security-token'] : false;


                        if (AWSAccessKeyId && xAmzSecurityToken && policy && signature && key) {

                            data.fields['x_amz_security_token'] = xAmzSecurityToken;
                            data.fields['file'] = file;


                            this.upload_file(data, onProgress).subscribe({
                                next: () => {
                                    observer.next({ data: data.fields, status: true });
                                    observer.complete();
                                },
                                error: (error) => {
                                    observer.next({ data: [], status: false, error });
                                    observer.complete();
                                },
                            });
                        } else {
                            observer.next({ data: [], status: false });
                            observer.complete();
                        }

                    } else {
                        observer.next({ data: [], status: false });
                        observer.complete();
                    }
                },
                error: (error) => {
                    observer.next({ data: [], status: false, error });
                    observer.complete();
                },
            });
        })
    }

    /**
     * @param onProgress Callback opcional invocado con el % (0-100) de avance de la SUBIDA
     * al bucket S3 (evento `UploadProgress` del XHR). No cubre ningún paso posterior al POST
     * (p. ej. procesamiento del lado del backend) — solo el tiempo real de transferencia del archivo.
     */
    upload_file(url_generated, onProgress?: (percent: number) => void) {

        const { fields } = url_generated;

        let fd = new FormData();
        fd.append("key", fields.key);
        fd.append("AWSAccessKeyId", fields.AWSAccessKeyId);
        fd.append("x-amz-security-token", fields.x_amz_security_token);
        fd.append("policy", fields.policy);
        fd.append("signature", fields.signature);
        fd.append("file", fields.file);

        // S3 responde sin cuerpo JSON parseable en éxito (204/201) -> responseType "text" evita que
        // Angular intente parsear como JSON y lo reporte como error incluso cuando la subida fue exitosa.
        // Un error real de S3 (403, etc.) sigue propagándose como error HTTP normal.
        return new Observable<string>((observer) => {
            this.http.post(url_generated.url, fd, {
                responseType: 'text',
                reportProgress: true,
                observe: 'events',
            }).subscribe({
                next: (event) => {
                    if (event.type === HttpEventType.UploadProgress && onProgress) {
                        const percent = event.total ? Math.round((event.loaded / event.total) * 100) : 0;
                        onProgress(percent);
                    } else if (event.type === HttpEventType.Response) {
                        observer.next(event.body ?? '');
                        observer.complete();
                    }
                },
                error: (error) => observer.error(error),
            });
        }).pipe(
            map(res => res)
        );
    }
}
